import type { MessageSubsection } from "@/types/types";

import cls from "./MessageSubsection.module.css";

export interface MessageSubsectionProps {
  subsection: MessageSubsection;
}

export function MessageSubsectionComponent({ subsection }: MessageSubsectionProps) {
  return <p className={`${cls.message} ${subsection.variant ? cls[subsection.variant] : ""}`}>{subsection.message}</p>;
}
